import type { ApiResponseBody, ApiSearchQuery } from '@/lib/api/api-type-helper';

// ---------------------------------------------------------------------------
// List API Types
// ---------------------------------------------------------------------------

export type GetTestAssetListQuery = ApiSearchQuery<'/v2/qa-force/test-assets', 'get'>;
export type GetTestAssetListResponse = ApiResponseBody<'/v2/qa-force/test-assets', 'get'>;
export type TestAssetListItem = GetTestAssetListResponse['items'][0];

// ---------------------------------------------------------------------------
// Count API Types
// ---------------------------------------------------------------------------

export type GetTestAssetCountQuery = ApiSearchQuery<'/v2/qa-force/test-assets/count', 'get'>;
export type GetTestAssetCountResponse = ApiResponseBody<'/v2/qa-force/test-assets/count', 'get'>;

// ---------------------------------------------------------------------------
// Domain enums
// ---------------------------------------------------------------------------

export const TestAssetStatus = {
  ACTIVE: 'ACTIVE',
  IN_MAINTENANCE: 'IN_MAINTENANCE',
  LEGACY: 'LEGACY'
} as const;
export type TestAssetStatus = (typeof TestAssetStatus)[keyof typeof TestAssetStatus];
const TEST_ASSET_STATUS_VALUES: ReadonlySet<string> = new Set(Object.values(TestAssetStatus));
export function isTestAssetStatus(value: string | null | undefined): value is TestAssetStatus {
  return value != null && TEST_ASSET_STATUS_VALUES.has(value);
}
export type TestAssetStatusFilter = TestAssetStatus | 'ALL';